import { Sector } from '../../model/sector';

export class SectorData {
  private static instance: SectorData;
  private selectedSectorIds: string[];
  private isBlocked: boolean;

  private constructor(initialSelectedSectorIds: string[] = []) {
    this.selectedSectorIds = initialSelectedSectorIds;
    this.isBlocked = false;
  }

  public static getInstance(): SectorData {
    if (!SectorData.instance) {
      SectorData.instance = new SectorData();
    }
    return SectorData.instance;
  }

  public getSelectedSectorsIds(): string[] {
    return this.isBlocked ? [] : this.selectedSectorIds;
  }

  public setSelectedSectorsIds(selectedSector: (string | Sector)[]): void {
    this.selectedSectorIds = selectedSector.map((sector) => (typeof sector === 'string' ? sector : sector.id));
  }

  public clean(): void {
    this.selectedSectorIds = [];
  }

  public blockSectors(): void {
    this.isBlocked = true;
  }

  public unblockSectors(): void {
    this.isBlocked = false;
  }

  public get areSectorsBlocked(): boolean {
    return this.isBlocked;
  }
}

export const SectorDataInstance = SectorData.getInstance();
